const saveStatuses = {
    SAVE_IN_PROGRESS: 'saveInProgress',
    SAVE_SUCCESSED: 'saveSuccessed',
    SAVE_FAILED: 'saveFailed',
    NOTHING_TO_SAVE: 'nothingToSave',
    INVALID_UNSAVED_VALUES: 'invalidUnsavedValues',
    READY_TO_SAVE: 'readyToSave'
};

export default saveStatuses;